import type { UserInfo } from "../services/types/user-types";

/**
 * Plans that include custom branding features
 */
const CUSTOM_BRANDING_PLANS = ["standard", "premium", "unlimited"];

/**
 * Check if user has access to custom branding features
 * (available for Standard, Premium, and Unlimited plans)
 */
export const hasCustomBrandingAccess = (user: UserInfo | null): boolean => {
  if (!user || !user.pricingPlanName) {
    return false;
  }

  return CUSTOM_BRANDING_PLANS.includes(
    user.pricingPlanName.toLowerCase(),
  );
};
